<template>
    <el-container>
        <el-header class="cate_mana_header">
            <el-input placeholder="请输入栏目名称" v-model="productName" style="width: 200px;"></el-input>
            <el-button type="primary" size="medium" style="margin-left: 10px" @click="addNewCate">新增栏目</el-button>
        </el-header>
        <el-main class="cate_mana_main">
            <el-table ref="multipleTable" :data="productList" tooltip-effect="dark" style="width: 100%">
                <el-table-column label="序号" type="index" width="120" align="center"></el-table-column>
                <el-table-column label="栏目名称" prop="productName" width="120" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="date" label="启用时间" align="center">
                    <template slot-scope="scope">{{ scope.row.date | formatDate }}</template>
                </el-table-column>
                <el-table-column label="操作" align="left">
                    <template slot-scope="scope">
                        <!-- <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button> -->
                        <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-main>
    </el-container>
</template>
<script>
import { postRequest, putRequest, deleteRequest, getRequest } from '@/utils/api';
export default {
    name: 'productList',
    methods: {
        addNewCate() {
            postRequest('/admin/product/add', { productName: this.productName }).then(
                resp => {
                    if (resp.status == 200) {
                        var json = resp.data;
                        this.$message({ type: 'success', message: '添加成功' });
                        this.productName = '';
                        this.refresh();
                    }
                },
                resp => {
                    if (resp.response.status == 403) {
                        this.$message({ type: 'error', message: resp.response.data });
                    }
                }
            );
        },

        handleEdit(index, row) {
            this.$prompt('请输入新名称', '编辑', { confirmButtonText: '更新', inputValue: row.productName, cancelButtonText: '取消' }).then(({ value }) => {
                //value就是输入值
                if (value == null || value.length == 0) {
                    this.$message({ type: 'info', message: '数据不能为空!' });
                } else {
                    postRequest('/admin/product/update', { id: row.id, productName: value }).then(
                        resp => {
                            var json = resp.data;
                            this.$message({ type: 'success', message: '更新成功' });
                            this.refresh();
                        },
                        resp => {
                            if (resp.response.status == 403) {
                                this.$message({ type: 'error', message: resp.response.data });
                            }
                        }
                    );
                }
            });
        },

        handleDelete(index, row) {
            this.$confirm('确认删除 ' + row.productName + ' ?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                this.deleteCate(row.id);
            });
        },

        deleteCate(id) {
            postRequest('/admin/product/delete', { id }).then(
                resp => {
                    var json = resp.data;
                    this.$message({ type: 'success', message: '删除成功' });
                    this.refresh();
                },
                resp => {
                    if (resp.response.status == 403) {
                        this.$message({ type: 'error', message: '删除失败' });
                    } else if (resp.response.status == 500) {
                        this.$message({ type: 'error', message: '该分类下尚有产品或服务器错误，删除失败!' });
                    }
                }
            );
        },
        refresh() {
            getRequest('/product/category/all').then(
                resp => {
                    this.productList = resp.data.data;
                },
                resp => {
                    if (resp.response.status == 403) {
                        this.$message({ type: 'error', message: '获取分类失败' });
                    }
                }
            );
        },
    },
    mounted: function() {
        this.refresh();
    },
    data() {
        return {
            productName: '',
            productList: [],
        };
    },
};
</script>
<style>
.cate_mana_header {
    background-color: #ececec;
    margin-top: 20px;
    padding-left: 5px;
    display: flex;
    justify-content: flex-start;
}

.cate_mana_main {
    /*justify-content: flex-start;*/
    display: flex;
    flex-direction: column;
    padding-left: 5px;
    background-color: #ececec;
    margin-top: 20px;
    padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/product/category.vue